import { createDynamicThunk } from ".";

/**
 * LIST Audits
 */
export const fetchAuditsThunk = createDynamicThunk({
  typePrefix: "audits/fetchAuditsThunk",
  useHandleSearch: true,
});

/**
 * Complete Audit
 */
export const completeAuditsThunk = createDynamicThunk({
  typePrefix: "audits/completeAuditsThunk",
  endpoint: "/audits/updateMul",
  method: "POST",
});

/**
 * Delete Audit
 */
export const deleteAuditsThunk = createDynamicThunk({
  typePrefix: "audits/deleteAuditsThunk",
  endpoint: "/audits/deleteMul",
  method: "POST",
});

/**
 * Soft-delete Audit
 */
export const softDeleteAuditsThunk = createDynamicThunk({
  typePrefix: "audits/softDeleteAuditsThunk",
  endpoint: "/audits/softDeleteMul",
  method: "POST",
});

/**
 * Fetch Processes by Deparmtent
 */
export const fetchProcessesByDeptThunk = createDynamicThunk({
  typePrefix: "audits/fetchProcessesByDeptThunk",
  endpoint: "/processes/findProcessesByDept",
  method: "POST",
});

/**
 * Fetch AuditForm by Process
 */
export const fetchAuditFormByProcessThunk = createDynamicThunk({
  typePrefix: "auditForms/fetchAuditFormByProcessThunk",
  endpoint: "/auditForms/findAuditFormByProcess",
  method: "POST",
});

/**
 * Fetch User by role and client
 */
export const fetchUserByRoleAndClientThunk = createDynamicThunk({
  typePrefix: "users/fetchUserByRoleAndClientThunk",
  endpoint: "/users/findUserByRoleAndClient",
  method: "POST",
});

/**
 * Fetch Clients
 */
export const fetchClientsThunk = createDynamicThunk({
  typePrefix: "fetchClientsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Departments
 */
export const fetchDepartmentsThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Download all
 */
export const downloadAllThunk = createDynamicThunk({
  typePrefix: "downloadAll",
  endpoint: "/downloadAll",
  method: "POST",
  responseType: "blob",
});

export const submitFeedbackThunk = createDynamicThunk({
  typePrefix: "audits/submitFeedbackThunk",
  endpoint: "/audits/submitFeedback",
  method: "PUT",
});

export const fetchUserInfoThunk = createDynamicThunk({
  typePrefix: "fetchUserInfoThunk",
  endpoint: "/users",
  method: "GET",
});

export const updateFormContentThunk = createDynamicThunk({
  typePrefix: "audits/updateFormContentThunk",
  endpoint: "/audits/updateFormContent",
  method: "PUT",
});

export const saveAuditThunk = createDynamicThunk({
  typePrefix: "audits/saveAudit",
  endpoint: "/audits",
  method: "POST",
});

export const getAuditDetailThunk = createDynamicThunk({
  typePrefix: "audits/getAuditDetail",
  endpoint: "/audits",
  method: "GET",
});

export const getAuditFormDetailThunk = createDynamicThunk({
  typePrefix: "auditForms/getAuditFormDetail",
  endpoint: "/auditForms",
  method: "GET",
});